import { ProductKeyTransferDb } from "../database/models/ProductKeyTransferDb";

export class ProductKeyTransfer {
    guid: string;

    sourceCompanyGuid: string;
    sourceCompanyName: string;
    sourceProductGuid: string;
    sourceProductName: string;

    destinationCompanyGuid: string;
    destinationCompanyName: string;
    destinationProductGuid: string;
    destinationProductName: string;

    requestedKeyCount: number;
    transferredKeyCount: number;

    transferredKeys: string[];
    transferredKeysTruncated: boolean;

    performedByEmail: string | null;
    transferredDate: Date;

    constructor(
        guid: string,
        sourceCompanyGuid: string,
        sourceCompanyName: string,
        sourceProductGuid: string,
        sourceProductName: string,
        destinationCompanyGuid: string,
        destinationCompanyName: string,
        destinationProductGuid: string,
        destinationProductName: string,
        requestedKeyCount: number,
        transferredKeyCount: number,
        transferredKeys: string[],
        transferredKeysTruncated: boolean,
        performedByEmail: string | null,
        transferredDate: Date,
    ) {
        this.guid = guid;

        this.sourceCompanyGuid = sourceCompanyGuid;
        this.sourceCompanyName = sourceCompanyName;
        this.sourceProductGuid = sourceProductGuid;
        this.sourceProductName = sourceProductName;

        this.destinationCompanyGuid = destinationCompanyGuid;
        this.destinationCompanyName = destinationCompanyName;
        this.destinationProductGuid = destinationProductGuid;
        this.destinationProductName = destinationProductName;

        this.requestedKeyCount = requestedKeyCount;
        this.transferredKeyCount = transferredKeyCount;

        this.transferredKeys = transferredKeys;
        this.transferredKeysTruncated = transferredKeysTruncated;

        this.performedByEmail = performedByEmail;
        this.transferredDate = transferredDate;
    }
}

export function ProductKeyTransferToDbMapper(model: ProductKeyTransfer) {
    const mapped: ProductKeyTransferDb = {
        guid: model.guid,

        sourceCompanyGuid: model.sourceCompanyGuid,
        sourceCompanyName: model.sourceCompanyName,
        sourceProductGuid: model.sourceProductGuid,
        sourceProductName: model.sourceProductName,

        destinationCompanyGuid: model.destinationCompanyGuid,
        destinationCompanyName: model.destinationCompanyName,
        destinationProductGuid: model.destinationProductGuid,
        destinationProductName: model.destinationProductName,

        requestedKeyCount: model.requestedKeyCount,
        transferredKeyCount: model.transferredKeyCount,

        transferredKeys: model.transferredKeys,
        transferredKeysTruncated: model.transferredKeysTruncated,

        performedByEmail: model.performedByEmail,
        transferredDate: model.transferredDate,
    };
    return mapped;
}

export function ProductKeyTransferFromDbMapper(db: ProductKeyTransferDb) {
    const mapped: ProductKeyTransfer = new ProductKeyTransfer(
        db.guid,
        db.sourceCompanyGuid,
        db.sourceCompanyName,
        db.sourceProductGuid,
        db.sourceProductName,
        db.destinationCompanyGuid,
        db.destinationCompanyName,
        db.destinationProductGuid,
        db.destinationProductName,
        db.requestedKeyCount,
        db.transferredKeyCount,
        db.transferredKeys ?? [],
        db.transferredKeysTruncated ?? false,
        db.performedByEmail,
        db.transferredDate,
    )
    return mapped;
}
